<template>
  <div class="container">
    <Header />
    <FullMap
      v-if="MapData"
      :areaCode="MapData.areaCode"
      :mapData="MapData.mapData"
      :legendConf="MapData.legendConf"
      :itemList="MapData.itemList"
      :title="MapData.title"
    />
    <div class="left-content">
      <BScroll>
        <div>
          <BasePanel title="旅游景区口碑指数" code="505">
            <!--<JingquKoubeiZhishu />-->
            <div class="youkelianggaikuang" style="min-height: 10px">
              <div class="range-box">
                <div class="info">
                  <div class="left">
                    游客满意度
                    <span>8.5</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="youkelianggaikuang" style="min-height: 10px">
              <div class="range-box">
                <div class="info">
                  <div class="left">
                    本市排名
                    <span>top3</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="youkelianggaikuang" style="min-height: 10px">
              <div class="range-box">
                <div class="info">
                  <div class="left">
最高项服务
                    <span>9.0</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="youkelianggaikuang" style="min-height: 10px">
              <div class="range-box">
                <div class="info">
                  <div class="left">
                    最需提升-安全
                    <span>5.2</span>
                  </div>
                </div>
              </div>
            </div>


            <!--<div class="bottom-info">
              <div class="left">
                排名最高景区
                <span>{{ data.highNames }}</span>
              </div>
            </div>
            <div class="right">
              排名最低景区
              <span>{{ data.lowNames }}</span>
            </div>-->
            <!--</div>-->
          </BasePanel>
          <BasePanel title="最新评论内容" code="506">
            <!--<JiudianZiyuanFenxi />-->
     <!--       <ul class="newCommentList">
                <li><img src="../assets/jingqukoubei/fave_nan.png" /><div>网红景点“天空之镜”青海茶卡盐湖的美丽风景令人沉醉，纯美干净的环境赏心悦目，可游客随手扔掉的垃圾则大煞风景，不仅破坏了“天空之镜”美感，亦存在污染环境、危及生态的隐…</div></li>
                <li><img src="../assets/jingqukoubei/fave_nan.png" /><div>网红景点“天空之镜”青海茶卡盐湖的美丽风景令人沉醉，纯美干净的环境赏心悦目，可游客随手扔掉的垃圾则大煞风景，不仅破坏了“天空之镜”美感，亦存在污染环境、危及生态的隐…</div></li>
                <li><img src="../assets/jingqukoubei/fave_nan.png" /><div>网红景点“天空之镜”青海茶卡盐湖的美丽风景令人沉醉，纯美干净的环境赏心悦目，可游客随手扔掉的垃圾则大煞风景，不仅破坏了“天空之镜”美感，亦存在污染环境、危及生态的隐…</div></li>
                <li><img src="../assets/jingqukoubei/fave_nan.png" /><div>网红景点“天空之镜”青海茶卡盐湖的美丽风景令人沉醉，纯美干净的环境赏心悦目，可游客随手扔掉的垃圾则大煞风景，不仅破坏了“天空之镜”美感，亦存在污染环境、危及生态的隐…</div></li>
                <li><img src="../assets/jingqukoubei/fave_nan.png" /><div>网红景点“天空之镜”青海茶卡盐湖的美丽风景令人沉醉，纯美干净的环境赏心悦目，可游客随手扔掉的垃圾则大煞风景，不仅破坏了“天空之镜”美感，亦存在污染环境、危及生态的隐…</div></li>
            </ul>-->
            <ul class="commentList">
              <li><img src="../assets/jingqukoubei/fave_nan.png" />
                <div class="comment">一山一水,无不透出江南的净值,倒也别有一番滋味</div>
                <div class="dec">
                  <div>2018-06-06 17:56:43</div>
                  <div>评论景区：宽街窄巷（2A I 风景）</div>
                  <div>数据源4 维度：全部</div>
                </div>
              </li>
              <li><img src="../assets/jingqukoubei/fave_nan.png" />
                <div class="comment">一山一水,无不透出江南的净值,倒也别有一番滋味</div>
                <div class="dec">
                  <div>2018-06-06 17:56:43</div>
                  <div>评论景区：宽街窄巷（2A I 风景）</div>
                  <div>数据源4 维度：全部</div>
                </div>
              </li>
              <li><img src="../assets/jingqukoubei/fave_nan.png" />
                <div class="comment">一山一水,无不透出江南的净值,倒也别有一番滋味</div>
                <div class="dec">
                  <div>2018-06-06 17:56:43</div>
                  <div>评论景区：宽街窄巷（2A I 风景）</div>
                  <div>数据源4 维度：全部</div>
                </div>
              </li>
              <li><img src="../assets/jingqukoubei/fave_nan.png" />
                <div class="comment">一山一水,无不透出江南的净值,倒也别有一番滋味</div>
                <div class="dec">
                  <div>2018-06-06 17:56:43</div>
                  <div>评论景区：宽街窄巷（2A I 风景）</div>
                  <div>数据源4 维度：全部</div>
                </div>
              </li>
              <li><img src="../assets/jingqukoubei/fave_nan.png" />
                <div class="comment">一山一水,无不透出江南的净值,倒也别有一番滋味</div>
                <div class="dec">
                  <div>2018-06-06 17:56:43</div>
                  <div>评论景区：宽街窄巷（2A I 风景）</div>
                  <div>数据源4 维度：全部</div>
                </div>
              </li>

            </ul>
          </BasePanel>
          <BasePanel title="全市景区平均口碑" code="501">
            <JinQuKoubeiRadar id="JinQuKoubeiRadar" :chartData="JingquPingjunKoubeiRadarData"/>
          </BasePanel></div
      ></BScroll>
    </div>
    <div class="right-content">
      <BScroll
        ><div>
          <BasePanel title="游客情绪分析" code="502">
            <div class="hunyinzhuangtai">
              <div class="chart-title">情绪占比图</div>
              <Pie3d :chartData="qingxuzhanbiData2" />
            </div>
            <!--<CityJingquKoubei/>-->
          </BasePanel>
          <BasePanel title="景区评测词云" code="507">
            <JingquPingceCiyun id="jingqupingceciyun" :chartData="jingquPingceCiyunData" v-if="jingquPingceCiyunData"/>
          </BasePanel>
          <BasePanel title="数据来源占比" code="503">
            <div  height = "300px">
              <SingleBar
                    :chartData="JingquZiyuanJibieJiegouData"
                    xy="y"
                    :barWidth="10"
                    :interval='"0"'
                    id="jingquziyuanjibiejiegou"
            />
            </div>
            <!--暂注释-->
            <!--<ShujuLaiyuanZhanbi  />-->
          </BasePanel>
          <!--    <BasePanel title="本市景区单项评分排名&#45;&#45;交通">
          <JingquDanxiangPingfenPaiming />
        </BasePanel>-->
          <BasePanel title="本市典型景区厕所评论" code="504">
            <div class="hunyinzhuangtai">
              <div class="chart-title">近一年厕所声量及好评率</div>
              <!--<DianxingCesuoPinglun />-->
              <DianxingCesuoPinglun
                id="jinyiniandianxingcesuopinglun"
                :chartData="dianXingJingquCesuoPinlunData"
                v-if="dianXingJingquCesuoPinlunData"
              />
            </div>
          </BasePanel>
        </div>
      </BScroll>
    </div>
    <div class="center-top-content" style="pointer-events: none;"></div>
    <div class="center-bottom-content">
      <HomeBottomBar
        id="homeBottomBar"
        :chartData="ShengLiangQushiDuidieData"
        v-if="ShengLiangQushiDuidieData"
      />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Common/Header.vue";
import BScroll from "@/components/Common/BScroll.vue";
import BasePanel from "@/components/Common/BasePanel.vue";
// import JingquKoubeiZhishu from "@/components/JingquKoubei/JingquKoubeiZhishu.vue";

import FullMap from "@/components/JingquKoubei/scenic/FullMap.vue";

import JinQuKoubeiRadar from "@/components/Echarts/JingquKoubei/JingquPingjunKoubei.vue";
import HomeBottomBar from "@/components/Echarts/JingquKoubei/HomeBottomLine.vue";

import Pie3d from "@/components/Highcharts/Pie3d";
import JingquPingceCiyun from "@/components/Echarts/JingquKoubei/JingquPingceCiyun.vue";
// import ShujuLaiyuanZhanbi from "@/components/Echarts/JingquKoubei/ShujuLaiyuanZhanbi.vue";

import DianxingCesuoPinglun from "@/components/Echarts/JingquKoubei/DianxingCesuoPinglun.vue";
import SingleBar from "@/components/Echarts/SingleBar.vue";

export default {
  name: "JingquKoubeiCity",
  components: {
    Header,
    BasePanel,
    BScroll,
    // JingquKoubeiZhishu,
    // JiudianZiyuanFenxi,
    // JingquZiyuanFenxi,
    // YuleZiyuanFenxi,
    // GouwuShangquanFenxi,
    // JiaotongTongdaFenxi,
    FullMap,
    JinQuKoubeiRadar,
    HomeBottomBar,
    Pie3d,
    JingquPingceCiyun,
    // ShujuLaiyuanZhanbi,
    DianxingCesuoPinglun,
      SingleBar
  },
  props: {
    data: {
      type: Object,
      default() {
        return {
          highNames: "宽街窄巷",
          lowNames: "XX景区"
        };
      }
    }
  },
  data() {
    return {
        JingquZiyuanJibieJiegouData:null,
      dianXingJingquCesuoPinlunData: null,
        JingquPingjunKoubeiRadarData:null,
      MapData: null,
      ShengLiangQushiDuidieData: null,
        jingquPingceCiyunData:null,
      qingxuzhanbiData2: null
    };
  },
  mounted() {
    this.$store.commit("setPageName", "景区口碑");
      // 请求景区评测词云


      fetch("/data/JingquKoubei/JingquPingceCiyun.json")
          .then(response => {

              return response.json();
          })
          .then(json => {
              this.jingquPingceCiyunData = json.data;
          });
    // 请求声量趋势堆叠图
    fetch("/data/JingquKoubei/ShengLiangQushiDuidie.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.ShengLiangQushiDuidieData = json.data;
      });
    // 请求地图数据
    fetch("/data/JingquKoubei/JingquMapData.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.MapData = json.data;
      });
    // 请求本市典型景区厕所评论

    fetch("/data/JingquKoubei/CesuoDetail/DianXingJingquCesuoPinglun.json")
      .then(response => {

        return response.json();
      })
      .then(json => {
          this.dianXingJingquCesuoPinlunData = json.data;
      });
      // 请求数据来源占比
      fetch(
          "/data/JingquKoubei/ShujuLaiyuanZhanbiData.json"
      )
          .then(response => {
              return response.json();
          })
          .then(json => {
              this.JingquZiyuanJibieJiegouData = json.data;
          });

// 请求游客情绪分析-情绪占比图
      fetch(
          "/data/JingquKoubei/YoukeQingxuFenxi.json"
      )
          .then(response => {
              return response.json();
          })
          .then(json => {
              this.qingxuzhanbiData2 = json.data;
          });
      fetch(
          "/data/JingquKoubei/JingquPingjunKoubeiRadar.json"
      )
          .then(response => {
              return response.json();
          })
          .then(json => {
              this.JingquPingjunKoubeiRadarData = json.data;
          });
  },
  methods: {}
};
</script>
<style scoped lang="less">
.youkelianggaikuang {
  min-height: 30px;
  width: 50%;
  height: 0.3rem;
  line-height: 0.3rem;
  float: left;
  padding-left: 0;
  box-sizing: border-box;
  margin-bottom: 0.2rem;
}

.youkelianggaikuang .range-box {
  /*    width: 100%;
    overflow: hidden;*/

  //add by zy
  width: 100%;
  height: 0.3rem;
  line-height: 0.3rem;
  float: left;
  padding-left: 0.1rem;
  box-sizing: border-box;
  margin-bottom: 0.2rem;
    font-size: 0.16rem;
}
.youkelianggaikuang .left {
  float: left;
}
.youkelianggaikuang .right {
  float: right;
}
.youkelianggaikuang .range-box .range {
  height: 0.12rem;
  margin: 0.22rem 0 0.2rem;
}
.youkelianggaikuang .range-box .range .left {
  width: 0%;
  height: 100%;
  background: #00ccff;
  transition: all 0.5s;
}
.youkelianggaikuang .range-box .range .right {
  width: 0%;
  height: 100%;
  background: #00d8af;
  transition: all 0.5s;
}
.youkelianggaikuang .range-box .left span {
  color: #00ccff;
  font-weight: bold;
}
.youkelianggaikuang .range-box .right span {
  color: #00d8af;
  font-weight: bold;
}
.youkelianggaikuang .bottom-info {
  margin-top: 0.28rem;
  font-weight: bold;
}
.youkelianggaikuang .bottom-info > div {
  width: 50%;
  height: 0.4rem;

  background-size: 95% 100%;
  text-align: center;
  line-height: 0.4rem;
}
.youkelianggaikuang .bottom-info > div > span {
  color: #00ccff;
  font-size: 0.22rem;
  margin: 0 0.04rem;
}
    .newCommentList{
        li{margin-bottom: 0.15rem;position: relative;}
        img{width: 0.3rem;height: 0.3rem;position: absolute;left: 0;}
        div{
            width: 3rem;
            height: 0.3rem;
            display: block;
            line-height: 0.3rem;
            font-size: 0.16rem;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-left: 0.36rem;
        }
    }


.commentList{
  text-align: left;
  li{
    position: relative;
    padding: 0.1rem 0.1rem;
    &:nth-child(even){
      background: #06527c;
    }
  }
  img{width: 0.5rem;height: 0.5rem;position: absolute;left: 0.1rem;}
  .comment,.dec{margin-left: 0.7rem;}
  .comment{
    width: auto;
    display: block;
    font-size: 0.16rem;
    color: #fff;
    margin-bottom: 0.05rem;
      white-space: nowrap;
      overflow: hidden;text-overflow: ellipsis;
  }
  .dec{
    color: #aaaaaa;
    font-size: 0.14rem;
    div{
      display: inline;
      margin-left: 0.2rem;
      &:first-child{
        margin-left: 0;
      }
    }
  }
}
</style>
